<template>
  <div>
    <hua-nav-bar :title="'访客系统注册'" style="margin-bottom: 10px"></hua-nav-bar>
    <div class="myBooking">
      <hua-form :label-width="120" :input-align="'right'">
        <hua-field
          type="number"
          v-model="phoneNumber"
          label="手机号"
          placeholder="请输入"
        />
        <hua-field v-model="validateCode" label="验证码" center placeholder="请输入">
          <template #button>
            <a id="code" style="color: blue" @click="getValidateCode">获取验证码</a>
          </template>
        </hua-field>
      </hua-form>
      <span class="tipText">请输入您使用的手机号进行注册</span>
      <div class="v-search-btn">
        <hua-button type="primary" block round @click.prevent="register">注册</hua-button>
      </div>
    </div>
  </div>
</template>
<script>
import rexp from "@/constants/rexp";
import api from "@/constants/api";
import common from "@/view/common.js"
export default {
  data() {
    return {
      phoneNumber: '',
      validateCode: '',
      state:''
    };
  },
  mounted() {
    let curHref = window.location.href;
    // 获取url中的state
    let hrefParam = common.getUrlParams(curHref);
    this.state = hrefParam.state
  },
  methods: {
    getValidateCode() {
      if (!this.phoneNumber) {
        return this.$toast("请输入手机号");
      } else if (!rexp.phone.test(this.phoneNumber)) {
        return this.$toast("手机号格式不正确");
      }
      api.getValidateCode(this.phoneNumber).then((res) => {});
    },
    register() {
      if (!this.phoneNumber) {
        return this.$toast("请输入手机号");
      } else if (!rexp.phone.test(this.phoneNumber)) {
        return this.$toast("手机号格式不正确");
      }
      if (!this.validateCode) {
        return this.$toast("请输入验证码");
      }
      let query = this.$route.query;
      let params = {
        type: query.type || "",
        code: query.code || "",
        state: this.state || "",
        verificationCode: this.validateCode,
        phone: this.phoneNumber,
      };
      api.register(params).then((res) => {
        return this.$toast("注册完成");
      }).catch((e) => {
          return this.$toast(e.errMsg);
      });
    },
  },
};
</script>
<style lang="less">
.tipText {
  display: block;
  color: #b0b0b0;
  margin: 15px 15px 20px;
}
.v-search-btn {
  margin: 0 15px;
}
</style>
